<template>
  <div class="container">
    <h4 class="title is-4">UUID generator</h4>
    <div class="container has-text-left">
      <div class="buttons">
        <b-button type="is-primary" class="is-small" @click="handleClickVersion1">Version 1</b-button>
        <b-button type="is-primary" class="is-small" @click="handleClickVersion4">Version 4</b-button>
        <b-button type="is-primary" class="is-small" @click="handleClickNil">Nil UUID</b-button>
      </div>
      <hr />
      <div class="block">
        <b-field label="Validate">
          <b-input v-model="text"/>
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-primary" class="is-small" @click="handleClickValidate">Validate</b-button>
      </div>
    </div>
    <div v-if="somethingClicked && response" class="container has-text-left">
      <hr />
      <div v-if="response.isValidation">
        <span>Valid:</span>
        <span style="margin-left: 0.5rem;">{{response.valid}}</span>
      </div>
      <div><span>Version:</span><span style="margin-left: 0.5rem;">{{response.version}}</span></div>
      <div v-if="!response.isValidation">
        <span>UUID:</span><span style="margin-left: 0.5rem; margin-right: 0.5rem;">{{response.uuid}}</span>
        <b-button type="is-primary" class="is-small" @click="handleCopy">Copy</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import {mapActions, mapGetters} from "vuex";

  export default {
    components: {
      BButton,
      BInput,
      BField
    },
    name: "screenuuid",
    data() {
      return {
        somethingClicked: false,
        text: '',
        response: null,
      };
    },
    computed: {
      ...mapGetters('uuid', ['response']),
    },
    methods: {
      ...mapActions('uuid', ['request']),
      handleClickVersion1() {
        this.text = '';
        this.somethingClicked = true;
        this.request({
          param: 'v1',
          cb: (data) => {
            this.response = {
              uuid: data.uuid,
              version: data.version,
            };
          }
        });
      },
      handleClickVersion4() {
        this.text = '';
        this.somethingClicked = true;
        this.request({
          param: 'v4',
          cb: (data) => {
            this.response = {
              uuid: data.uuid,
              version: data.version,
            };
          }
        });
      },
      handleClickNil() {
        this.text = '';
        this.somethingClicked = true;
        this.request({
          param: 'nil',
          cb: (data) => {
            this.response = {
              uuid: data.uuid,
              version: data.version,
            };
          }
        });
      },
      handleClickValidate() {
        this.somethingClicked = true;
        this.request({
          param: this.text,
          cb: (data) => {
            this.response = {
              uuid: data.param,
              valid: data.valid,
              version: data.version || '-',
              isValidation: true,
            };
          }
        });
      },
      handleCopy() {
        if (this.response && this.response.uuid) {
          navigator.clipboard.writeText(this.response.uuid);
        }
      }
    },
    mounted() {
      this.somethingClicked = false;
      this.text = '';
    },
    unmounted() {
      this.somethingClicked = false;
      this.text = '';
    }
  }
</script>

<style scoped>

</style>
